import { defineComponent } from "vue";
import { decodeMessageText } from "../util.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MessageText",
  props: ["data"],
  setup(__props) {
    const props = __props;
    const handleTextMessageShowContext = (text) => decodeMessageText(text);
    return { __sfc: true, props, handleTextMessageShowContext };
  }
});
export {
  _sfc_main as default
};
